import getQueryParams from 'utils/getQueryParams';
import type { DiceNotification } from '../components/Notifications/generateNotificationEntity';
import type { AreaOfResponsibility } from '../types/aor';

import {
  UPDATE_CURRENT_INCIDENT_REQUEST,
  UPDATE_CURRENT_INCIDENT_SUCCESS,
  UPDATE_CURRENT_INCIDENT_ERROR,
  CREATE_INCIDENT_REQUEST,
  CREATE_INCIDENT_SUCCESS,
  CREATE_INCIDENT_ERROR,
  UPDATE_INCIDENT_GROUP_REQUEST,
  UPDATE_INCIDENT_GROUP_SUCCESS,
  UPDATE_INCIDENT_GROUP_ERROR,
  UPDATE_CURRENTLY_SELECTED_GROUP_REQUEST,
  UPDATE_CURRENTLY_SELECTED_GROUP_SUCCESS,
  UPDATE_CURRENTLY_SELECTED_GROUP_ERROR,
  SET_CLONE_DEFAULTS_REQUEST,
  SET_CLONE_DEFAULTS_SUCCESS,
  SET_CLONE_DEFAULTS_ERROR,
  FETCH_CLONE_DEFAULTS_REQUEST,
  FETCH_CLONE_DEFAULTS_SUCCESS,
  FETCH_CLONE_DEFAULTS_ERROR,
  ADD_USER_SCHEDULE_REQUEST,
  ADD_USER_SCHEDULE_SUCCESS,
  ADD_USER_SCHEDULE_ERROR,
  GET_ALL_USER_SCHEDULE,
  GET_ALL_USER_SCHEDULE_REQUEST,
  GET_ALL_USER_SCHEDULE_SUCCESS,
} from 'constants/dice-action-types';

import {
  CREATE_OR_GET_USER_REQUEST,
  CREATE_OR_GET_USER_SUCCESS,
  CREATE_OR_GET_USER_ERROR,
  FETCH_GROUPS_REQUEST,
  FETCH_GROUPS_SUCCESS,
  FETCH_GROUPS_ERROR,
  FETCH_GROUPS_FOR_USER_REQUEST,
  FETCH_GROUPS_FOR_USER_SUCCESS,
  FETCH_GROUPS_FOR_USER_ERROR,
  CREATE_GROUP_REQUEST,
  CREATE_GROUP_SUCCESS,
  CREATE_GROUP_ERROR,
  FETCH_INCIDENTS_REQUEST,
  FETCH_INCIDENTS_SUCCESS,
  FETCH_INCIDENTS_ERROR,
  INVITE_GROUP_MEMBER_REQUEST,
  INVITE_GROUP_MEMBER_SUCCESS,
  INVITE_GROUP_MEMBER_ERROR,
  UPDATE_CURRENTLY_SELECTED_REQUEST,
  UPDATE_CURRENTLY_SELECTED_SUCCESS,
  UPDATE_CURRENTLY_SELECTED_ERROR,
  UPDATE_USER_PROFILE_SETTINGS_REQUEST,
  UPDATE_USER_PROFILE_SETTINGS_SUCCESS,
  UPDATE_USER_PROFILE_SETTINGS_ERROR,
  BULK_USER_IMPORT_REQUEST,
  BULK_USER_IMPORT_SUCCESS,
  BULK_USER_IMPORT_ERROR,
  GET_USER_BY_ID_REQUEST,
  GET_USER_BY_ID_SUCCESS,
  GET_USER_BY_ID_ERROR,
  FETCH_USER_GROUPS_ROLES_INCIDENTS_REQUEST,
  FETCH_USER_GROUPS_ROLES_INCIDENTS_SUCCESS,
  FETCH_USER_GROUPS_ROLES_INCIDENTS_ERROR,
  UPDATE_INCIDENT_STATUS,
} from 'constants/profile-action-types';

import {
  GET_ROSTER_FOR_INCIDENT_REQUEST,
  GET_ROSTER_FOR_INCIDENT_SUCCESS,
  GET_ROSTER_FOR_INCIDENT_ERROR,
  ADD_USER_TO_INCIDENT_BY_ADMIN_ERROR,
  REMOVE_USER_FROM_INCIDENT_BY_ADMIN_REQUEST,
  REMOVE_USER_FROM_INCIDENT_BY_ADMIN_SUCCESS,
  REMOVE_USER_FROM_INCIDENT_BY_ADMIN_ERROR,
  REMOVE_SELF_FROM_INCIDENT_REQUEST,
  REMOVE_SELF_FROM_INCIDENT_SUCCESS,
  REMOVE_SELF_FROM_INCIDENT_ERROR,
  GET_INCIDENT_LOGS,
  UPDATE_INCIDENT_LOGS_WITH_WORKLOG,
  ADD_SCHEDULE_TO_INCIDENT_SUCCESS,
  ADD_SCHEDULE_TO_INCIDENT_REQUEST,
} from 'constants/incident-action-types';

import {
  FETCH_ALL_ROLES_IN_GROUP_REQUEST,
  FETCH_ALL_ROLES_IN_GROUP_SUCCESS,
  FETCH_ALL_ROLES_IN_GROUP_ERROR,
  FETCH_ALL_ROLE_ASSIGNMENTS_IN_GROUP_REQUEST,
  FETCH_ALL_ROLE_ASSIGNMENTS_IN_GROUP_SUCCESS,
  FETCH_ALL_ROLE_ASSIGNMENTS_IN_GROUP_ERROR,
  CREATE_ROLE_REQUEST,
  CREATE_ROLE_SUCCESS,
  CREATE_ROLE_ERROR,
  EDIT_ROLE_REQUEST,
  EDIT_ROLE_SUCCESS,
  EDIT_ROLE_ERROR,
  DELETE_ROLE_REQUEST,
  DELETE_ROLE_SUCCESS,
  DELETE_ROLE_ERROR,
  ASSIGN_ROLE_REQUEST,
  ASSIGN_ROLE_SUCCESS,
  ASSIGN_ROLE_ERROR,
  UNASSIGN_ROLE_REQUEST,
  UNASSIGN_ROLE_SUCCESS,
  UNASSIGN_ROLE_ERROR,
  FETCH_ROSTERS_FOR_GROUPS_REQUEST,
  FETCH_ROSTERS_FOR_GROUPS_SUCCESS,
  FETCH_ROSTERS_FOR_GROUPS_ERROR,
  FETCH_ALL_PERMISSIONS_REQUEST,
  FETCH_ALL_PERMISSIONS_SUCCESS,
  FETCH_ALL_PERMISSIONS_ERROR,
  FETCH_ALL_PERMISSIONS_IN_ROLE_REQUEST,
  FETCH_ALL_PERMISSIONS_IN_ROLE_SUCCESS,
  FETCH_ALL_PERMISSIONS_IN_ROLE_ERROR,
  REMOVE_USER_FROM_GROUP_REQUEST,
  REMOVE_USER_FROM_GROUP_SUCCESS,
  REMOVE_USER_FROM_GROUP_ERROR,
  EDIT_GROUP_REQUEST,
  EDIT_GROUP_SUCCESS,
  EDIT_GROUP_ERROR,
  DELETE_GROUP_REQUEST,
  DELETE_GROUP_SUCCESS,
  DELETE_GROUP_ERROR,
  FETCH_INCIDENTS_FOR_GROUP_REQUEST,
  FETCH_INCIDENTS_FOR_GROUP_SUCCESS,
  FETCH_INCIDENTS_FOR_GROUP_ERROR,
} from 'constants/role-action-types';

import {
  VALIDATE_RBAC_PERMISSION_FOR_ACTION_REQUEST,
  VALIDATE_RBAC_PERMISSION_FOR_ACTION_SUCCESS,
  VALIDATE_RBAC_PERMISSION_FOR_ACTION_ERROR,
} from 'constants/validation-action-types';

import {
  SEND_NOTIFICATION_REQUEST,
  SEND_NOTIFICATION_SUCCESS,
  SEND_NOTIFICATION_ERROR,
  FETCH_NOTIFICATIONS_REQUEST,
  FETCH_NOTIFICATIONS_SUCCESS,
  FETCH_NOTIFICATIONS_ERROR,
  UPSERT_NOTIFICATION_REQUEST,
  UPSERT_NOTIFICATION_SUCCESS,
  UPSERT_NOTIFICATION_ERROR,
  DELETE_NOTIFICATION_REQUEST,
  DELETE_NOTIFICATION_SUCCESS,
  DELETE_NOTIFICATION_ERROR,
  FETCH_NOTIFICATION_LOG_REQUEST,
  FETCH_NOTIFICATION_LOG_SUCCESS,
  FETCH_NOTIFICATION_LOG_ERROR,
  FETCH_NOTIFICATION_LOG_INSTANCE_REQUEST,
  FETCH_NOTIFICATION_LOG_INSTANCE_SUCCESS,
  FETCH_NOTIFICATION_LOG_INSTANCE_ERROR,
  FETCH_ALL_NOTIFICATION_LOG_SUMMARIES_REQUEST,
  FETCH_ALL_NOTIFICATION_LOG_SUMMARIES_SUCCESS,
  FETCH_ALL_NOTIFICATION_LOG_SUMMARIES_ERROR,
  FETCH_ALL_DISTRIBUTION_LIST,
  CREATE_DISTRIBUTION_LIST,
  DELETE_DISTRIBUTION_LIST_ITEM,
  CLEAR_NOTIFICATION_STATUS,
  CLEAR_UPSERT_NOTIFICATION_STATUS,
} from 'constants/notification-action-types';

import {
  CHANGE_FEATURE_FLAGS_SUCCESS,
  CHANGE_FEATURE_FLAGS_ERROR,
} from 'constants/feature-flag-action-types';

import {
  EXPORT_FORM_TO_PDF_REQUEST,
  EXPORT_FORM_TO_PDF_SUCCESS,
  EXPORT_FORM_TO_PDF_ERROR,
  GET_ALL_BRANCH,
  GET_ALL_DIVISION,
} from 'constants/form-action-types';

import { GET_ALL_ACTIVITY_LOG } from 'constants/incident-report-Incident-types';

import { FETCH_ALL_USER_WORKSPACE } from 'constants/workspace-action-types';

import {
  UPDATE_CURRENT_AOR_REQUEST,
  UPDATE_CURRENT_AOR_SUCCESS,
  UPDATE_CURRENT_AOR_ERROR,
} from 'constants/location-action-types';

import {
  ADD_TASK_COMMENT_REQUEST,
  ADD_TASK_COMMENT_SUCCESS,
  FETCH_TASK_LIST_ERROR,
  FETCH_TASK_LIST_REQUEST,
  FETCH_TASK_LIST_SUCCESS,
  GET_ALL_TASK_COMMENT,
  GET_ALL_TASK_COMMENT_ERROR,
  GET_ALL_TASK_COMMENT_REQUEST,
  GET_ALL_TASK_LOGS,
  GET_ALL_TASK_LOGS_ERROR,
  GET_ALL_TASK_LOGS_REQUEST,
  SAVE_TASK_DATA_ERROR,
  SAVE_TASK_DATA_REQUEST,
  SAVE_TASK_DATA_SUCCESS,
} from 'constants/task-management-types';

import {
  GENERATE_TEAMS_SITE_REQUEST,
  GENERATE_TEAMS_SITE_SUCCESS,
  GENERATE_TEAMS_SITE_ERROR,
  UPLOAD_FILE_TO_TEAMS_REQUEST,
  UPLOAD_FILE_TO_TEAMS_SUCCESS,
  UPLOAD_FILE_TO_TEAMS_ERROR,
  GET_TEAMS_TEMPLATE_SUCCESS,
  UPDATE_TEAMS_TENANT_ID,
  CHECK_TEAMS,
  CHECK_TEAMS_STATUS_SUCCESS,
} from 'constants/teams-action-types';
import {
  mergeOrgFeatureFlags,
  withHubOnlyDefault,
  withHwcgDefault,
  withUscgFocRequirementsDefault,
  withPositionWorkspacesWhenFoc,
  type FeatureFlag,
} from 'utils/featureFlags';
import { DistributionList } from 'hooks/useDistributionLists';

export type AppState = {
  // Loading flags
  areGroupsLoaded: boolean;
  areIncidentsLoaded: boolean;
  inviteGroupMemberSuccess: boolean;
  inviteGroupMemberError: boolean | any;
  isUpdateIncidentGroupLoaded: boolean;
  isFetchAllOrgScopedRolesInGroupLoaded: boolean;
  isCreateRoleLoaded: boolean;
  isEditRoleLoaded: boolean;
  isAssignRoleLoaded: boolean;
  isFetchRostersForGroupsLoaded: boolean;
  isValidateRBACPermissionForActionLoaded: boolean;
  isGetRosterForIncidentLoaded: boolean;
  isAddUserToIncidentByAdminLoaded: boolean;
  isAddNonUserToIncidentByAdminLoaded: boolean;
  isSendNotificationLoaded: boolean;
  isUpsertNotificationLoaded: boolean;
  isAddUserScheduleLoaded: boolean;
  isAddUserScheduleError: boolean;
  isGetAllUserScheduleLoaded: boolean;
  isFetchCloneDefaultsLoaded: boolean;
  isSetCloneDefaultsLoaded: boolean;
  isFetchNotificationLogLoaded: boolean;
  isFetchNotificationLogInstanceLoaded: boolean;
  isUpdateCurrentlySelectedLoaded: boolean;
  isFetchUserGroupsRolesIncidentsLoaded: boolean;
  isTaskListDataLoaded: boolean;
  saveTaskSuccess: boolean;
  isGenerateTeamsSiteLoaded: boolean;
  isUploadFileToTeamsLoaded: boolean;
  isBulkUserImportLoaded?: boolean;

  // Core data
  currentlySelectedGroup: Group | undefined;
  groups: Group[] | undefined;
  incidents: IncidentAugmented[] | undefined;
  currentIncident:
    | (IncidentAugmented & { teams_status?: string })
    | undefined
    | null;
  user: User | undefined;
  focusUser?: User | undefined;
  groupsForUser?: Group[];
  incidentsForGroup?: any[];

  // Notifications
  notifications: DiceNotification[];
  notificationLog?: any;
  notificationLogInstance?: any;
  allNotificationLogSummaries?: any[];
  sendNotificationResult?: any;
  upsertedNotification?: DiceNotification;
  distributionListItems: DistributionList[];

  // Feature flags
  featureFlags: FeatureFlag[];

  // Incident logs
  incidentLogs?: {
    incidentMembersLogs: Array<{
      incident_member_id: string;
      logs: any[];
    }>;
  };

  // User schedule
  allUserSchedule?: any[];

  // Forms
  exportedFormsToPDF: Array<{ id: string; [key: string]: any }>;

  // Clone defaults
  cloneDefaults?: any;

  // User groups roles incidents
  userGroupsRolesIncidents: any[];

  // AOR (Area of Responsibility)
  currentAOR: AreaOfResponsibility | undefined;

  // Planning worksheet
  planningWorksheet: Record<string, any>;

  // Branches and divisions
  allBranches: any[];
  allDivisions: any[];

  // Activity logs
  diceActivityLogs: any[];

  // Workspaces
  alluserWorkspaces: any[];

  // Teams
  teamsTemplates: any[];
  tenantId: string | undefined;
  teamStatusFromIncident: any | null;
  checkTeamCounter: {
    incidentId: string;
    count: number;
    timeout: NodeJS.Timeout | null;
  };

  // Task management
  taskList: any[];
  totalTaskList?: number;
  allTaskComments: any[];
  allTaskLogs: any[];

  // API error handling
  apiError: any | null;

  // Additional fields that may be set by actions
  allOrgScopedRolesInGroup?: any[];
  allRoleAssignmentsInGroup?: any[];
  rostersForGroups?: any[];
  allPermissions?: any[];
  allPermissionsInRole?: any[];
  validateRBACPermissionForActionResult?: any;
};

// Action type definitions
type AppAction =
  | { type: typeof UPDATE_INCIDENT_STATUS; payload: any }
  | { type: typeof CREATE_OR_GET_USER_REQUEST }
  | { type: typeof CREATE_OR_GET_USER_SUCCESS; payload: User }
  | { type: typeof CREATE_OR_GET_USER_ERROR; payload: any }
  | { type: typeof GET_USER_BY_ID_REQUEST }
  | { type: typeof GET_USER_BY_ID_SUCCESS; payload: User }
  | { type: typeof GET_USER_BY_ID_ERROR }
  | { type: typeof FETCH_GROUPS_FOR_USER_REQUEST }
  | { type: typeof FETCH_GROUPS_FOR_USER_SUCCESS; payload: Group[] }
  | { type: typeof FETCH_GROUPS_FOR_USER_ERROR }
  | { type: typeof FETCH_GROUPS_REQUEST }
  | {
      type: typeof FETCH_GROUPS_SUCCESS;
      payload: { groups: Group[]; group_id?: string };
    }
  | { type: typeof FETCH_GROUPS_ERROR }
  | { type: typeof CREATE_GROUP_REQUEST }
  | {
      type: typeof CREATE_GROUP_SUCCESS;
      groups: Group[];
      group_name: string;
    }
  | { type: typeof CREATE_GROUP_ERROR }
  | { type: typeof FETCH_INCIDENTS_REQUEST }
  | {
      type: typeof FETCH_INCIDENTS_SUCCESS;
      payload: {
        incidents: IncidentAugmented[];
        queryIncidentId?: string;
      };
    }
  | { type: typeof FETCH_INCIDENTS_ERROR }
  | { type: typeof FETCH_INCIDENTS_FOR_GROUP_REQUEST }
  | { type: typeof FETCH_INCIDENTS_FOR_GROUP_SUCCESS; payload: any[] }
  | { type: typeof FETCH_INCIDENTS_FOR_GROUP_ERROR }
  | { type: typeof INVITE_GROUP_MEMBER_REQUEST }
  | { type: typeof INVITE_GROUP_MEMBER_SUCCESS }
  | { type: typeof INVITE_GROUP_MEMBER_ERROR; payload: any }
  | { type: typeof UPDATE_CURRENT_INCIDENT_REQUEST }
  | { type: typeof UPDATE_CURRENT_INCIDENT_SUCCESS; payload: IncidentAugmented }
  | { type: typeof UPDATE_CURRENT_INCIDENT_ERROR }
  | { type: typeof CREATE_INCIDENT_REQUEST }
  | { type: typeof CREATE_INCIDENT_SUCCESS; payload: IncidentAugmented }
  | { type: typeof CREATE_INCIDENT_ERROR }
  | { type: typeof UPDATE_INCIDENT_GROUP_REQUEST }
  | {
      type: typeof UPDATE_INCIDENT_GROUP_SUCCESS;
      payload: { incident_id: string; group_id: string };
    }
  | { type: typeof UPDATE_INCIDENT_GROUP_ERROR }
  | { type: typeof FETCH_ALL_ROLES_IN_GROUP_REQUEST }
  | { type: typeof FETCH_ALL_ROLES_IN_GROUP_SUCCESS; payload: any[] }
  | { type: typeof FETCH_ALL_ROLES_IN_GROUP_ERROR }
  | { type: typeof FETCH_ALL_ROLE_ASSIGNMENTS_IN_GROUP_REQUEST }
  | { type: typeof FETCH_ALL_ROLE_ASSIGNMENTS_IN_GROUP_SUCCESS; payload: any[] }
  | { type: typeof FETCH_ALL_ROLE_ASSIGNMENTS_IN_GROUP_ERROR }
  | { type: typeof CREATE_ROLE_REQUEST }
  | { type: typeof CREATE_ROLE_SUCCESS; payload: any }
  | { type: typeof CREATE_ROLE_ERROR }
  | { type: typeof EDIT_ROLE_REQUEST }
  | { type: typeof EDIT_ROLE_SUCCESS; payload: any }
  | { type: typeof EDIT_ROLE_ERROR }
  | { type: typeof DELETE_ROLE_REQUEST }
  | { type: typeof DELETE_ROLE_SUCCESS; payload: any }
  | { type: typeof DELETE_ROLE_ERROR }
  | { type: typeof ASSIGN_ROLE_REQUEST }
  | { type: typeof ASSIGN_ROLE_SUCCESS; payload: any }
  | { type: typeof ASSIGN_ROLE_ERROR }
  | { type: typeof UNASSIGN_ROLE_REQUEST }
  | { type: typeof UNASSIGN_ROLE_SUCCESS; payload: any }
  | { type: typeof UNASSIGN_ROLE_ERROR }
  | { type: typeof FETCH_ROSTERS_FOR_GROUPS_REQUEST }
  | { type: typeof FETCH_ROSTERS_FOR_GROUPS_SUCCESS; payload: any[] }
  | { type: typeof FETCH_ROSTERS_FOR_GROUPS_ERROR }
  | { type: typeof FETCH_ALL_PERMISSIONS_REQUEST }
  | { type: typeof FETCH_ALL_PERMISSIONS_SUCCESS; payload: any[] }
  | { type: typeof FETCH_ALL_PERMISSIONS_ERROR }
  | { type: typeof FETCH_ALL_PERMISSIONS_IN_ROLE_REQUEST }
  | { type: typeof FETCH_ALL_PERMISSIONS_IN_ROLE_SUCCESS; payload: any[] }
  | { type: typeof FETCH_ALL_PERMISSIONS_IN_ROLE_ERROR }
  | { type: typeof VALIDATE_RBAC_PERMISSION_FOR_ACTION_REQUEST }
  | { type: typeof VALIDATE_RBAC_PERMISSION_FOR_ACTION_SUCCESS; payload: any }
  | { type: typeof VALIDATE_RBAC_PERMISSION_FOR_ACTION_ERROR }
  | { type: typeof GET_ROSTER_FOR_INCIDENT_REQUEST }
  | { type: typeof GET_ROSTER_FOR_INCIDENT_SUCCESS; payload: any[] }
  | { type: typeof GET_ROSTER_FOR_INCIDENT_ERROR }
  | { type: typeof ADD_USER_TO_INCIDENT_BY_ADMIN_ERROR }
  | { type: typeof REMOVE_USER_FROM_INCIDENT_BY_ADMIN_REQUEST }
  | { type: typeof REMOVE_USER_FROM_INCIDENT_BY_ADMIN_SUCCESS; payload: any }
  | { type: typeof REMOVE_USER_FROM_INCIDENT_BY_ADMIN_ERROR }
  | { type: typeof REMOVE_SELF_FROM_INCIDENT_REQUEST }
  | { type: typeof REMOVE_SELF_FROM_INCIDENT_SUCCESS; payload: any }
  | { type: typeof REMOVE_SELF_FROM_INCIDENT_ERROR }
  | { type: typeof REMOVE_USER_FROM_GROUP_REQUEST }
  | { type: typeof REMOVE_USER_FROM_GROUP_SUCCESS; payload: any }
  | { type: typeof REMOVE_USER_FROM_GROUP_ERROR }
  | { type: typeof EDIT_GROUP_REQUEST }
  | { type: typeof EDIT_GROUP_SUCCESS; payload: Group }
  | { type: typeof EDIT_GROUP_ERROR }
  | { type: typeof DELETE_GROUP_REQUEST }
  | { type: typeof DELETE_GROUP_SUCCESS; payload: any }
  | { type: typeof DELETE_GROUP_ERROR }
  | { type: typeof UPDATE_CURRENTLY_SELECTED_GROUP_REQUEST }
  | { type: typeof UPDATE_CURRENTLY_SELECTED_GROUP_SUCCESS; payload: Group }
  | { type: typeof UPDATE_CURRENTLY_SELECTED_GROUP_ERROR }
  | { type: typeof SEND_NOTIFICATION_REQUEST }
  | { type: typeof SEND_NOTIFICATION_SUCCESS; payload: any }
  | { type: typeof SEND_NOTIFICATION_ERROR }
  | { type: typeof FETCH_NOTIFICATIONS_REQUEST }
  | { type: typeof FETCH_NOTIFICATIONS_SUCCESS; payload: DiceNotification[] }
  | { type: typeof FETCH_NOTIFICATIONS_ERROR }
  | { type: typeof FETCH_ALL_NOTIFICATION_LOG_SUMMARIES_REQUEST }
  | {
      type: typeof FETCH_ALL_NOTIFICATION_LOG_SUMMARIES_SUCCESS;
      payload: any[];
    }
  | { type: typeof FETCH_ALL_NOTIFICATION_LOG_SUMMARIES_ERROR }
  | { type: typeof UPSERT_NOTIFICATION_REQUEST }
  | { type: typeof UPSERT_NOTIFICATION_SUCCESS; payload: DiceNotification }
  | { type: typeof UPSERT_NOTIFICATION_ERROR }
  | { type: typeof DELETE_NOTIFICATION_REQUEST }
  | { type: typeof DELETE_NOTIFICATION_SUCCESS; payload: any }
  | { type: typeof DELETE_NOTIFICATION_ERROR }
  | { type: typeof CHANGE_FEATURE_FLAGS_SUCCESS; payload: FeatureFlag[] }
  | { type: typeof CHANGE_FEATURE_FLAGS_ERROR }
  | { type: typeof EXPORT_FORM_TO_PDF_REQUEST }
  | {
      type: typeof EXPORT_FORM_TO_PDF_SUCCESS;
      payload: { id: string; [key: string]: any };
    }
  | { type: typeof EXPORT_FORM_TO_PDF_ERROR }
  | { type: typeof UPDATE_USER_PROFILE_SETTINGS_REQUEST }
  | { type: typeof UPDATE_USER_PROFILE_SETTINGS_SUCCESS; payload: any }
  | { type: typeof UPDATE_USER_PROFILE_SETTINGS_ERROR }
  | { type: typeof BULK_USER_IMPORT_REQUEST }
  | { type: typeof BULK_USER_IMPORT_SUCCESS; payload: any[] }
  | { type: typeof BULK_USER_IMPORT_ERROR }
  | { type: typeof SET_CLONE_DEFAULTS_REQUEST }
  | { type: typeof SET_CLONE_DEFAULTS_SUCCESS; payload: any }
  | { type: typeof SET_CLONE_DEFAULTS_ERROR }
  | { type: typeof FETCH_CLONE_DEFAULTS_REQUEST }
  | { type: typeof FETCH_CLONE_DEFAULTS_SUCCESS; payload: any }
  | { type: typeof FETCH_CLONE_DEFAULTS_ERROR }
  | { type: typeof FETCH_NOTIFICATION_LOG_REQUEST }
  | { type: typeof FETCH_NOTIFICATION_LOG_SUCCESS; payload: any }
  | { type: typeof FETCH_NOTIFICATION_LOG_ERROR }
  | { type: typeof FETCH_NOTIFICATION_LOG_INSTANCE_REQUEST }
  | { type: typeof FETCH_NOTIFICATION_LOG_INSTANCE_SUCCESS; payload: any }
  | { type: typeof FETCH_NOTIFICATION_LOG_INSTANCE_ERROR }
  | { type: typeof UPDATE_CURRENTLY_SELECTED_REQUEST }
  | {
      type: typeof UPDATE_CURRENTLY_SELECTED_SUCCESS;
      payload: { group_guid: string; route: string; aor_id: string };
    }
  | { type: typeof UPDATE_CURRENTLY_SELECTED_ERROR }
  | { type: typeof FETCH_USER_GROUPS_ROLES_INCIDENTS_REQUEST }
  | { type: typeof FETCH_USER_GROUPS_ROLES_INCIDENTS_SUCCESS; payload: any[] }
  | { type: typeof FETCH_USER_GROUPS_ROLES_INCIDENTS_ERROR }
  | { type: typeof CREATE_DISTRIBUTION_LIST; payload: DistributionList }
  | { type: typeof FETCH_ALL_DISTRIBUTION_LIST; payload: DistributionList[] }
  | { type: typeof DELETE_DISTRIBUTION_LIST_ITEM; payload: string }
  | { type: typeof CLEAR_NOTIFICATION_STATUS }
  | { type: typeof CLEAR_UPSERT_NOTIFICATION_STATUS }
  | { type: typeof GET_INCIDENT_LOGS; payload: AppState['incidentLogs'] }
  | {
      type: typeof UPDATE_INCIDENT_LOGS_WITH_WORKLOG;
      payload: { id: string; logs: any[] };
    }
  | { type: typeof ADD_SCHEDULE_TO_INCIDENT_REQUEST }
  | { type: typeof ADD_SCHEDULE_TO_INCIDENT_SUCCESS }
  | { type: typeof ADD_USER_SCHEDULE_REQUEST }
  | { type: typeof ADD_USER_SCHEDULE_SUCCESS }
  | { type: typeof ADD_USER_SCHEDULE_ERROR }
  | { type: typeof GET_ALL_USER_SCHEDULE_REQUEST }
  | { type: typeof GET_ALL_USER_SCHEDULE_SUCCESS }
  | { type: typeof GET_ALL_USER_SCHEDULE; payload: any[] }
  | { type: typeof UPDATE_CURRENT_AOR_REQUEST }
  | { type: typeof UPDATE_CURRENT_AOR_SUCCESS; payload: AreaOfResponsibility }
  | { type: typeof UPDATE_CURRENT_AOR_ERROR }
  | { type: typeof GET_ALL_ACTIVITY_LOG; payload: any[] }
  | { type: typeof GET_ALL_BRANCH; payload: any[] }
  | { type: typeof GET_ALL_DIVISION; payload: any[] }
  | { type: typeof FETCH_ALL_USER_WORKSPACE; payload: any[] }
  | { type: typeof FETCH_TASK_LIST_REQUEST }
  | {
      type: typeof FETCH_TASK_LIST_SUCCESS;
      payload: { taskList?: any[]; count: number };
    }
  | { type: typeof FETCH_TASK_LIST_ERROR }
  | { type: typeof SAVE_TASK_DATA_REQUEST }
  | { type: typeof SAVE_TASK_DATA_SUCCESS }
  | { type: typeof SAVE_TASK_DATA_ERROR }
  | { type: typeof GENERATE_TEAMS_SITE_REQUEST; payload: any }
  | { type: typeof GENERATE_TEAMS_SITE_SUCCESS }
  | { type: typeof GENERATE_TEAMS_SITE_ERROR }
  | { type: typeof CHECK_TEAMS; payload: AppState['checkTeamCounter'] }
  | {
      type: typeof CHECK_TEAMS_STATUS_SUCCESS;
      payload: { incidentId: string; teamsStatusInfo: any };
    }
  | { type: typeof GET_TEAMS_TEMPLATE_SUCCESS; payload: any[] }
  | { type: typeof UPDATE_TEAMS_TENANT_ID; payload: string }
  | { type: typeof UPLOAD_FILE_TO_TEAMS_REQUEST }
  | { type: typeof UPLOAD_FILE_TO_TEAMS_SUCCESS }
  | { type: typeof UPLOAD_FILE_TO_TEAMS_ERROR }
  | { type: typeof ADD_TASK_COMMENT_REQUEST }
  | { type: typeof ADD_TASK_COMMENT_SUCCESS }
  | { type: typeof GET_ALL_TASK_COMMENT_REQUEST }
  | { type: typeof GET_ALL_TASK_COMMENT_ERROR }
  | { type: typeof GET_ALL_TASK_COMMENT; payload: any[] }
  | { type: typeof GET_ALL_TASK_LOGS_REQUEST }
  | { type: typeof GET_ALL_TASK_LOGS_ERROR }
  | { type: typeof GET_ALL_TASK_LOGS; payload: any[] };

export const initialState: AppState = {
  areGroupsLoaded: true,
  areIncidentsLoaded: true,
  inviteGroupMemberSuccess: false,
  inviteGroupMemberError: false,
  isUpdateIncidentGroupLoaded: true,
  isFetchAllOrgScopedRolesInGroupLoaded: true,
  isCreateRoleLoaded: true,
  isEditRoleLoaded: true,
  isAssignRoleLoaded: true,
  isFetchRostersForGroupsLoaded: true,
  isValidateRBACPermissionForActionLoaded: true,
  isGetRosterForIncidentLoaded: true,
  isAddUserToIncidentByAdminLoaded: true,
  isAddNonUserToIncidentByAdminLoaded: true,
  currentlySelectedGroup: undefined,
  groups: undefined,
  incidents: undefined,
  currentIncident: undefined,
  isSendNotificationLoaded: true,
  isUpsertNotificationLoaded: true,
  notifications: [],
  featureFlags: ['AI_CHAT_V2', 'ACTION_TICKETS', 'CREATE_REPORT_TEMPLATES'],
  incidentLogs: undefined,
  isAddUserScheduleLoaded: true,
  isAddUserScheduleError: false,
  isGetAllUserScheduleLoaded: true,
  exportedFormsToPDF: [],
  isFetchCloneDefaultsLoaded: true,
  isSetCloneDefaultsLoaded: true,
  notificationLog: undefined,
  isFetchNotificationLogLoaded: true,
  isFetchNotificationLogInstanceLoaded: true,
  distributionListItems: [],
  isUpdateCurrentlySelectedLoaded: true,
  isFetchUserGroupsRolesIncidentsLoaded: true,
  userGroupsRolesIncidents: [],
  currentAOR: undefined,
  allBranches: [],
  allDivisions: [],
  planningWorksheet: {},
  diceActivityLogs: [],
  alluserWorkspaces: [],
  teamsTemplates: [],
  tenantId: undefined,
  user: undefined,

  // task management
  taskList: [],
  isTaskListDataLoaded: true,
  saveTaskSuccess: false,
  allTaskComments: [],
  allTaskLogs: [],

  // api error handle data
  apiError: null,
  isGenerateTeamsSiteLoaded: true,
  isUploadFileToTeamsLoaded: true,
  teamStatusFromIncident: null,
  checkTeamCounter: { incidentId: '', count: 0, timeout: null },
};

const appReducer = (
  state: AppState = initialState,
  action: AppAction
): AppState => {
  const queryParams = getQueryParams(document.location.search) as Record<
    string,
    string
  >;

  let newCurrentIncident: IncidentAugmented | undefined;

  switch (action.type) {
    case UPDATE_INCIDENT_STATUS:
      return {
        ...state,
        // @ts-expect-error Current incident should be defined here
        currentIncident: {
          ...state.currentIncident,
          teams_status: action.payload,
        },
      };
    case CREATE_OR_GET_USER_SUCCESS:
      return {
        ...state,
        user: action.payload,
        apiError: null,
      };
    case CREATE_OR_GET_USER_ERROR:
      return {
        ...state,
        apiError: action.payload,
      };
    case GET_USER_BY_ID_SUCCESS:
      return {
        ...state,
        focusUser: action.payload,
      };
    case FETCH_GROUPS_FOR_USER_SUCCESS:
      return {
        ...state,
        groupsForUser: action.payload,
      };
    case FETCH_GROUPS_FOR_USER_ERROR:
      return {
        ...state,
        groupsForUser: [],
      };
    case FETCH_GROUPS_REQUEST:
      return {
        ...state,
        areGroupsLoaded: false,
      };
    case FETCH_GROUPS_SUCCESS: {
      const {
        // @ts-expect-error User should be defined here
        user: { currently_selected },
      } = state;
      const { group_guid: persistedGroupId } = currently_selected || {};

      let currentlySelectedGroupId: string | undefined;
      if (queryParams.group) {
        currentlySelectedGroupId = queryParams.group;
      } else if (action.payload.group_id) {
        currentlySelectedGroupId = action.payload.group_id;
      } else {
        currentlySelectedGroupId = persistedGroupId;
      }

      const currentlySelectedGroup = action.payload.groups.find((group) => {
        // if there is an existing selected group use that. otherwise take the first one.
        return currentlySelectedGroupId
          ? group.group_guid === currentlySelectedGroupId
          : true;
      });

      const activeFlags =
        currentlySelectedGroup &&
        currentlySelectedGroup.default_settings &&
        // @ts-expect-error active_flags is not typed
        currentlySelectedGroup.default_settings.active_flags;

      let featureFlags = state.featureFlags;

      if (activeFlags) {
        // remove duplicates...
        featureFlags = Array.from(
          new Set([
            ...featureFlags,
            ...mergeOrgFeatureFlags<FeatureFlag>(activeFlags),
          ])
        );
      }

      featureFlags = withHubOnlyDefault(
        featureFlags,
        currentlySelectedGroup?.group_name
      );
      featureFlags = withHwcgDefault(
        featureFlags,
        currentlySelectedGroup?.group_name
      );
      featureFlags = withUscgFocRequirementsDefault(
        featureFlags,
        currentlySelectedGroup?.group_name
      );
      featureFlags = withPositionWorkspacesWhenFoc(featureFlags);

      return {
        ...state,
        areGroupsLoaded: true,
        groups: action.payload.groups,
        ...(currentlySelectedGroup ? { currentlySelectedGroup } : {}),
        featureFlags,
      };
    }
    case FETCH_GROUPS_ERROR:
      return {
        ...state,
        areGroupsLoaded: true,
        groups: [],
      };
    case CREATE_GROUP_SUCCESS: {
      const addedGroup = action.groups.find(
        (group) => group.group_name === action.group_name
      );
      const newCurrentlySelectedGroup =
        (!!addedGroup && addedGroup) || undefined;
      return {
        ...state,
        groups: action.groups,
        currentIncident: null,
        currentlySelectedGroup: newCurrentlySelectedGroup,
      };
    }
    case FETCH_INCIDENTS_REQUEST:
      return {
        ...state,
        areIncidentsLoaded: false,
      };
    case FETCH_INCIDENTS_SUCCESS:
      if (state.currentIncident) {
        newCurrentIncident = action.payload.incidents.find(
          (incident) => incident.id === state.currentIncident?.id
        );

        // missmatch between app and server
        if (!newCurrentIncident) {
          newCurrentIncident = action.payload.incidents[0];
        }
      } else {
        // the persisted version should take precedence
        newCurrentIncident = action.payload.incidents.find(
          (incident) =>
            incident.id === (newCurrentIncident && newCurrentIncident.id)
        );

        if (action.payload.incidents.length && !newCurrentIncident) {
          if (action.payload.queryIncidentId) {
            newCurrentIncident = action.payload.incidents.find(
              (incident) => incident.id === action.payload.queryIncidentId
            );
          } else {
            // @ts-expect-error User should be be defined here
            const incidentId = state.user?.currently_selected?.incident_id;
            newCurrentIncident = action.payload.incidents.filter(
              (incident) => !incident.archived && incident.id === incidentId
            )[0];

            if (!newCurrentIncident) {
              newCurrentIncident = action.payload.incidents.filter(
                (incident) =>
                  incident.group_guid ===
                  state.currentlySelectedGroup?.group_guid
              )[0];
            }
          }
        }

        if (
          (newCurrentIncident && newCurrentIncident.group_guid) !==
          (state.currentlySelectedGroup &&
            state.currentlySelectedGroup.group_guid)
        ) {
          newCurrentIncident = undefined;
        }
      }

      return {
        ...state,
        areIncidentsLoaded: true,
        incidents: action.payload.incidents.filter(
          (incident) => !incident.archived
        ),
        currentIncident: newCurrentIncident,
      };
    case FETCH_INCIDENTS_ERROR:
      return {
        ...state,
        areIncidentsLoaded: true,
        incidents: [],
      };
    case FETCH_INCIDENTS_FOR_GROUP_SUCCESS:
      return {
        ...state,
        incidentsForGroup: action.payload,
      };
    case FETCH_INCIDENTS_FOR_GROUP_ERROR:
      return {
        ...state,
        incidentsForGroup: [],
      };
    case INVITE_GROUP_MEMBER_REQUEST:
      return {
        ...state,
        inviteGroupMemberSuccess: false,
        inviteGroupMemberError: false,
      };
    case INVITE_GROUP_MEMBER_SUCCESS:
      return {
        ...state,
        inviteGroupMemberSuccess: true,
        inviteGroupMemberError: false,
      };
    case INVITE_GROUP_MEMBER_ERROR:
      return {
        ...state,
        inviteGroupMemberSuccess: false,
        inviteGroupMemberError: action.payload,
      };
    case UPDATE_CURRENT_INCIDENT_SUCCESS:
      return {
        ...state,
        currentIncident: action.payload,
      };
    case CREATE_INCIDENT_SUCCESS:
      return {
        ...state,
        currentIncident: action.payload,
      };
    case UPDATE_INCIDENT_GROUP_REQUEST:
      return {
        ...state,
        isUpdateIncidentGroupLoaded: false,
      };
    case UPDATE_INCIDENT_GROUP_SUCCESS: {
      const currentIncidents = state.incidents || [];

      const adjustedIncidents = currentIncidents.map((incident) => {
        if (incident.id === action.payload.incident_id) {
          return {
            ...incident,
            group_guid: action.payload.group_id,
          };
        } else {
          return incident;
        }
      });
      return {
        ...state,
        isUpdateIncidentGroupLoaded: true,
        currentIncident: state.currentIncident
          ? {
              ...state.currentIncident,
              group_guid: action.payload.group_id,
            }
          : undefined,
        incidents: adjustedIncidents,
      };
    }
    case UPDATE_INCIDENT_GROUP_ERROR:
      return {
        ...state,
        isUpdateIncidentGroupLoaded: true,
      };
    case FETCH_ALL_ROLES_IN_GROUP_REQUEST:
      return {
        ...state,
        isFetchAllOrgScopedRolesInGroupLoaded: false,
      };
    case FETCH_ALL_ROLES_IN_GROUP_SUCCESS:
      return {
        ...state,
        isFetchAllOrgScopedRolesInGroupLoaded: true,
        allOrgScopedRolesInGroup: action.payload,
      };
    case FETCH_ALL_ROLES_IN_GROUP_ERROR:
      return {
        ...state,
        isFetchAllOrgScopedRolesInGroupLoaded: true,
        allOrgScopedRolesInGroup: [],
      };
    case FETCH_ALL_ROLE_ASSIGNMENTS_IN_GROUP_SUCCESS:
      return {
        ...state,
        allRoleAssignmentsInGroup: action.payload,
      };
    case FETCH_ALL_ROLE_ASSIGNMENTS_IN_GROUP_ERROR:
      return {
        ...state,
        allRoleAssignmentsInGroup: [],
      };
    case CREATE_ROLE_REQUEST:
      return {
        ...state,
        isCreateRoleLoaded: false,
      };
    case CREATE_ROLE_SUCCESS:
      return {
        ...state,
        isCreateRoleLoaded: true,
      };
    case CREATE_ROLE_ERROR:
      return {
        ...state,
        isCreateRoleLoaded: true,
      };
    case EDIT_ROLE_REQUEST:
      return {
        ...state,
        isEditRoleLoaded: false,
      };
    case EDIT_ROLE_SUCCESS:
      return {
        ...state,
        isEditRoleLoaded: true,
      };
    case EDIT_ROLE_ERROR:
      return {
        ...state,
        isEditRoleLoaded: true,
      };
    case ASSIGN_ROLE_REQUEST:
      return {
        ...state,
        isAssignRoleLoaded: false,
      };
    case ASSIGN_ROLE_SUCCESS:
      return {
        ...state,
        isAssignRoleLoaded: true,
      };
    case ASSIGN_ROLE_ERROR:
      return {
        ...state,
        isAssignRoleLoaded: true,
      };
    case FETCH_ROSTERS_FOR_GROUPS_REQUEST:
      return {
        ...state,
        isFetchRostersForGroupsLoaded: false,
      };
    case FETCH_ROSTERS_FOR_GROUPS_SUCCESS:
      return {
        ...state,
        isFetchRostersForGroupsLoaded: true,
        rostersForGroups: action.payload,
      };
    case FETCH_ROSTERS_FOR_GROUPS_ERROR:
      return {
        ...state,
        isFetchRostersForGroupsLoaded: true,
        rostersForGroups: [],
      };
    case FETCH_ALL_PERMISSIONS_SUCCESS:
      return {
        ...state,
        allPermissions: action.payload,
      };
    case FETCH_ALL_PERMISSIONS_ERROR:
      return {
        ...state,
        allPermissions: [],
      };
    case FETCH_ALL_PERMISSIONS_IN_ROLE_SUCCESS:
      return {
        ...state,
        allPermissionsInRole: action.payload,
      };
    case FETCH_ALL_PERMISSIONS_IN_ROLE_ERROR:
      return {
        ...state,
        allPermissionsInRole: [],
      };
    case VALIDATE_RBAC_PERMISSION_FOR_ACTION_REQUEST:
      return {
        ...state,
        isValidateRBACPermissionForActionLoaded: false,
      };
    case VALIDATE_RBAC_PERMISSION_FOR_ACTION_SUCCESS:
      return {
        ...state,
        isValidateRBACPermissionForActionLoaded: true,
        validateRBACPermissionForActionResult: action.payload,
      };
    case VALIDATE_RBAC_PERMISSION_FOR_ACTION_ERROR:
      return {
        ...state,
        isValidateRBACPermissionForActionLoaded: true,
        validateRBACPermissionForActionResult: {},
      };
    case GET_ROSTER_FOR_INCIDENT_REQUEST:
      return {
        ...state,
        isGetRosterForIncidentLoaded: false,
      };
    case GET_ROSTER_FOR_INCIDENT_SUCCESS:
      return {
        ...state,
        isGetRosterForIncidentLoaded: true,
      };
    case GET_ROSTER_FOR_INCIDENT_ERROR:
      return {
        ...state,
        isGetRosterForIncidentLoaded: true,
      };
    case ADD_USER_TO_INCIDENT_BY_ADMIN_ERROR:
      return {
        ...state,
        isAddUserToIncidentByAdminLoaded: true,
      };
    case REMOVE_SELF_FROM_INCIDENT_SUCCESS:
      return {
        ...state,
        currentIncident: undefined,
      };
    case REMOVE_SELF_FROM_INCIDENT_ERROR:
      return {
        ...state,
        currentIncident: undefined,
      };
    case EDIT_GROUP_SUCCESS:
      return {
        ...state,
        currentlySelectedGroup: {
          ...state.currentlySelectedGroup,
          ...action.payload,
        },
        groups: [
          // @ts-expect-error Groups should be be defined here
          ...state.groups.map((group) => {
            if (group.group_guid === action.payload.group_guid) {
              const updatedGroup = {
                ...group,
                ...action.payload,
              };

              return updatedGroup;
            }

            return group;
          }),
        ],
      };
    case UPDATE_CURRENTLY_SELECTED_GROUP_REQUEST:
      return {
        ...state,
        inviteGroupMemberError: undefined,
      };
    case UPDATE_CURRENTLY_SELECTED_GROUP_SUCCESS: {
      const currentlySelectedGroup = action.payload;

      const activeFlags =
        currentlySelectedGroup &&
        currentlySelectedGroup.default_settings &&
        // @ts-expect-error active_flags is not typed
        currentlySelectedGroup.default_settings.active_flags;

      let featureFlags = state.featureFlags;

      if (activeFlags) {
        const allFlags = [
          ...featureFlags,
          ...mergeOrgFeatureFlags<FeatureFlag>(activeFlags),
        ];

        featureFlags = Array.from(new Set(allFlags));
      }

      featureFlags = withHubOnlyDefault(
        featureFlags,
        currentlySelectedGroup?.group_name
      );
      featureFlags = withHwcgDefault(
        featureFlags,
        currentlySelectedGroup?.group_name
      );
      featureFlags = withUscgFocRequirementsDefault(
        featureFlags,
        currentlySelectedGroup?.group_name
      );
      featureFlags = withPositionWorkspacesWhenFoc(featureFlags);

      return {
        ...state,
        currentlySelectedGroup,
        featureFlags,
      };
    }
    case SEND_NOTIFICATION_REQUEST:
      return {
        ...state,
        isSendNotificationLoaded: false,
      };
    case SEND_NOTIFICATION_SUCCESS:
      return {
        ...state,
        isSendNotificationLoaded: true,
        sendNotificationResult: action.payload,
      };
    case SEND_NOTIFICATION_ERROR:
      return {
        ...state,
        isSendNotificationLoaded: true,
      };
    case FETCH_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notifications: action.payload,
      };
    case FETCH_NOTIFICATIONS_ERROR:
      return {
        ...state,
        notifications: [],
      };
    case FETCH_ALL_NOTIFICATION_LOG_SUMMARIES_SUCCESS:
      return {
        ...state,
        allNotificationLogSummaries: action.payload,
      };
    case FETCH_ALL_NOTIFICATION_LOG_SUMMARIES_ERROR:
      return {
        ...state,
        allNotificationLogSummaries: [],
      };

    case UPSERT_NOTIFICATION_REQUEST:
      return {
        ...state,
        isUpsertNotificationLoaded: false,
      };
    case UPSERT_NOTIFICATION_SUCCESS:
      return {
        ...state,
        isUpsertNotificationLoaded: true,
        upsertedNotification: action.payload,
      };
    case UPSERT_NOTIFICATION_ERROR:
      return {
        ...state,
        isUpsertNotificationLoaded: true,
      };
    case CHANGE_FEATURE_FLAGS_SUCCESS:
      return {
        ...state,
        featureFlags: withPositionWorkspacesWhenFoc(
          withUscgFocRequirementsDefault(
            withHwcgDefault(
              action.payload,
              state.currentlySelectedGroup?.group_name
            ),
            state.currentlySelectedGroup?.group_name
          )
        ),
      };
    case EXPORT_FORM_TO_PDF_SUCCESS:
      return {
        ...state,
        exportedFormsToPDF: [
          ...state.exportedFormsToPDF.filter(
            (form) => form.id !== action.payload.id
          ),
          action.payload,
        ],
      };
    case EXPORT_FORM_TO_PDF_ERROR:
      return {
        ...state,
        exportedFormsToPDF: [],
      };

    case UPDATE_USER_PROFILE_SETTINGS_SUCCESS:
      return {
        ...state,
        // @ts-expect-error User should be be defined here
        user: {
          ...state.user,
          profile_settings: action.payload,
          user_name: action.payload.userName || state.user?.user_name,
        },
      };
    case BULK_USER_IMPORT_REQUEST:
      return {
        ...state,
        isBulkUserImportLoaded: false,
      };
    case BULK_USER_IMPORT_SUCCESS:
      return {
        ...state,
        isBulkUserImportLoaded: true,
      };
    case BULK_USER_IMPORT_ERROR:
      return {
        ...state,
        isBulkUserImportLoaded: true,
      };
    case SET_CLONE_DEFAULTS_REQUEST:
      return {
        ...state,
        isSetCloneDefaultsLoaded: false,
      };
    case SET_CLONE_DEFAULTS_SUCCESS:
      return {
        ...state,
        isSetCloneDefaultsLoaded: true,
        cloneDefaults: action.payload,
      };
    case SET_CLONE_DEFAULTS_ERROR:
      return {
        ...state,
        isSetCloneDefaultsLoaded: true,
      };
    case FETCH_CLONE_DEFAULTS_REQUEST:
      return {
        ...state,
        isFetchCloneDefaultsLoaded: false,
      };
    case FETCH_CLONE_DEFAULTS_SUCCESS:
      return {
        ...state,
        isFetchCloneDefaultsLoaded: true,
        cloneDefaults: action.payload,
      };
    case FETCH_CLONE_DEFAULTS_ERROR:
      return {
        ...state,
        isFetchCloneDefaultsLoaded: true,
      };
    case FETCH_NOTIFICATION_LOG_REQUEST:
      return {
        ...state,
        isFetchNotificationLogLoaded: false,
      };
    case FETCH_NOTIFICATION_LOG_SUCCESS:
      return {
        ...state,
        notificationLog: action.payload,
        isFetchNotificationLogLoaded: true,
      };
    case FETCH_NOTIFICATION_LOG_ERROR:
      return {
        ...state,
        isFetchNotificationLogLoaded: true,
      };
    case FETCH_NOTIFICATION_LOG_INSTANCE_REQUEST:
      return {
        ...state,
        isFetchNotificationLogInstanceLoaded: false,
      };
    case FETCH_NOTIFICATION_LOG_INSTANCE_SUCCESS:
      return {
        ...state,
        notificationLogInstance: action.payload,
        isFetchNotificationLogInstanceLoaded: true,
      };
    case FETCH_NOTIFICATION_LOG_INSTANCE_ERROR:
      return {
        ...state,
        isFetchNotificationLogInstanceLoaded: true,
      };
    case UPDATE_CURRENTLY_SELECTED_REQUEST:
      return {
        ...state,
        isUpdateCurrentlySelectedLoaded: false,
      };
    case UPDATE_CURRENTLY_SELECTED_SUCCESS:
      return {
        ...state,
        isUpdateCurrentlySelectedLoaded: true,
        // @ts-expect-error User should be be defined here
        user: {
          ...state.user,
          currently_selected: action.payload,
        },
      };
    case UPDATE_CURRENTLY_SELECTED_ERROR:
      return {
        ...state,
        isUpdateCurrentlySelectedLoaded: true,
      };
    case FETCH_USER_GROUPS_ROLES_INCIDENTS_REQUEST:
      return {
        ...state,
        isFetchUserGroupsRolesIncidentsLoaded: false,
      };
    case FETCH_USER_GROUPS_ROLES_INCIDENTS_SUCCESS:
      return {
        ...state,
        isFetchUserGroupsRolesIncidentsLoaded: true,
        userGroupsRolesIncidents: action.payload,
      };
    case FETCH_USER_GROUPS_ROLES_INCIDENTS_ERROR:
      return {
        ...state,
        isFetchUserGroupsRolesIncidentsLoaded: true,
      };

    case CREATE_DISTRIBUTION_LIST:
      return {
        ...state,
        distributionListItems: [
          ...state.distributionListItems.filter(
            (ele) => ele.id !== action.payload.id
          ),
          action.payload,
        ],
      };
    case FETCH_ALL_DISTRIBUTION_LIST:
      return {
        ...state,
        distributionListItems: [...action.payload],
      };
    case DELETE_DISTRIBUTION_LIST_ITEM:
      return {
        ...state,
        distributionListItems: [
          ...state.distributionListItems.filter(
            (ele) => ele.id !== action.payload
          ),
        ],
      };
    case CLEAR_NOTIFICATION_STATUS:
      return {
        ...state,
        sendNotificationResult: undefined,
      };
    case CLEAR_UPSERT_NOTIFICATION_STATUS:
      return {
        ...state,
        upsertedNotification: undefined,
      };

    case GET_INCIDENT_LOGS:
      return {
        ...state,
        incidentLogs: action.payload,
      };
    case UPDATE_INCIDENT_LOGS_WITH_WORKLOG: {
      if (!state.incidentLogs) {
        return state;
      }
      const incidentLogs = { ...state.incidentLogs };
      const index = incidentLogs.incidentMembersLogs.findIndex(
        (ele) => ele.incident_member_id === action.payload.id
      );
      if (index >= 0) {
        incidentLogs.incidentMembersLogs[index] = {
          ...incidentLogs.incidentMembersLogs[index],
          logs: action.payload.logs,
        };
      }
      if (action.payload.logs.length > 0) {
        return {
          ...state,
          incidentLogs: incidentLogs,
        };
      }
      return state;
    }

    case ADD_USER_SCHEDULE_REQUEST:
      return {
        ...state,
        isAddUserScheduleLoaded: false,
        isAddUserScheduleError: false,
      };
    case ADD_USER_SCHEDULE_SUCCESS:
      return {
        ...state,
        isAddUserScheduleLoaded: true,
      };
    case ADD_USER_SCHEDULE_ERROR:
      return {
        ...state,
        isAddUserScheduleError: true,
        isAddUserScheduleLoaded: true,
      };
    case GET_ALL_USER_SCHEDULE_REQUEST:
      return {
        ...state,
        isGetAllUserScheduleLoaded: false,
      };
    case GET_ALL_USER_SCHEDULE_SUCCESS:
      return {
        ...state,
        isGetAllUserScheduleLoaded: true,
      };
    case GET_ALL_USER_SCHEDULE:
      return {
        ...state,
        allUserSchedule: action.payload,
      };
    case UPDATE_CURRENT_AOR_SUCCESS: {
      return {
        ...state,
        currentAOR: action.payload,
      };
    }
    case GET_ALL_ACTIVITY_LOG:
      return {
        ...state,
        diceActivityLogs: action.payload,
      };
    case GET_ALL_BRANCH:
      return {
        ...state,
        allBranches: action.payload,
      };
    case GET_ALL_DIVISION:
      return {
        ...state,
        allDivisions: action.payload,
      };
    case FETCH_ALL_USER_WORKSPACE:
      return {
        ...state,
        alluserWorkspaces: action.payload,
      };
    case FETCH_TASK_LIST_REQUEST:
      return {
        ...state,
        taskList: [],
        totalTaskList: 0,
        isTaskListDataLoaded: false,
      };
    case FETCH_TASK_LIST_SUCCESS:
      return {
        ...state,
        taskList: action.payload.taskList || [],
        totalTaskList: action.payload.count,
        isTaskListDataLoaded: true,
      };
    case FETCH_TASK_LIST_ERROR:
      return {
        ...state,
        isTaskListDataLoaded: true,
      };
    case SAVE_TASK_DATA_REQUEST:
      return {
        ...state,
        saveTaskSuccess: false,
      };
    case SAVE_TASK_DATA_SUCCESS:
      return {
        ...state,
        saveTaskSuccess: true,
      };
    case SAVE_TASK_DATA_ERROR:
      return {
        ...state,
        saveTaskSuccess: false,
      };
    case GENERATE_TEAMS_SITE_REQUEST: {
      return {
        ...state,
        teamStatusFromIncident: action.payload,
        isGenerateTeamsSiteLoaded: false,
      };
    }
    case GENERATE_TEAMS_SITE_SUCCESS: {
      return {
        ...state,
        isGenerateTeamsSiteLoaded: true,
        teamStatusFromIncident: null,
        checkTeamCounter: { incidentId: '', count: 0, timeout: null },
      };
    }
    case CHECK_TEAMS: {
      return {
        ...state,
        checkTeamCounter: action.payload,
      };
    }
    case CHECK_TEAMS_STATUS_SUCCESS: {
      if (state.currentIncident?.id === action.payload.incidentId) {
        return {
          ...state,
          currentIncident: {
            ...state.currentIncident,
            ...action.payload.teamsStatusInfo,
          },
        };
      } else {
        return {
          ...state,
        };
      }
    }
    case GET_TEAMS_TEMPLATE_SUCCESS: {
      return {
        ...state,
        teamsTemplates: action.payload,
      };
    }
    case UPDATE_TEAMS_TENANT_ID: {
      return {
        ...state,
        tenantId: action.payload,
      };
    }
    case GENERATE_TEAMS_SITE_ERROR: {
      return {
        ...state,
        isGenerateTeamsSiteLoaded: true,
      };
    }
    case UPLOAD_FILE_TO_TEAMS_REQUEST: {
      return {
        ...state,
        isUploadFileToTeamsLoaded: false,
      };
    }
    case UPLOAD_FILE_TO_TEAMS_SUCCESS: {
      return {
        ...state,
        isUploadFileToTeamsLoaded: true,
      };
    }
    case UPLOAD_FILE_TO_TEAMS_ERROR: {
      return {
        ...state,
        isUploadFileToTeamsLoaded: true,
      };
    }
    case GET_ALL_TASK_COMMENT: {
      return {
        ...state,
        allTaskComments: action.payload,
      };
    }
    case GET_ALL_TASK_LOGS: {
      return {
        ...state,
        allTaskLogs: action.payload,
      };
    }
    default:
      return state;
  }
};

export default appReducer;
